/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import config from '../stores/config';
import AppModelMapper from '../utils/modelMapper/appModelMapper';
import { ACTIVE_SESSIONS_STATUS } from '../utils/modelMapper/appModelMapper/appJsonConstants';
import { getAppInstallationStatus } from './appTileAnalytics';
import { AppsPanelSkeleton } from '../stores/skeleton';

class ProgressBarAnalytics {
    getEventSubtype(appModel) {
        const command = AppModelMapper.getActionInProgress(appModel);
        let cmdSubtypeString = '';
        switch (command
            && typeof command === 'string'
            && command.toLowerCase()) {
        case 'install':
            cmdSubtypeString = 'installing';
            break;
        case 'update':
            cmdSubtypeString = 'updating';
            break;
        case 'uninstall':
            cmdSubtypeString = 'uninstalling';
            break;
        default:
            break;
        }
        return cmdSubtypeString;
    }

    sendProgressAnalytics(appModel, progressData) {
        if (progressData
            && progressData.status
            && Object.prototype.hasOwnProperty.call(progressData, 'status')) {
            const status = progressData.status.toLowerCase();
            if (status !== ACTIVE_SESSIONS_STATUS.COMPLETED
                && status !== ACTIVE_SESSIONS_STATUS.INPROGRESS) {
                return;
            }
            let prevProgress;
            let currProgress;
            const obj = {};
            const componentParams = {};
            obj.event = {
                workflow: 'Apps',
                subcategory: AppsPanelSkeleton.selectedSectionFilter,
                type: 'inline',
                subtype: this.getEventSubtype(progressData),
            };
            obj.content = {
                id: appModel.sapcode,
                name: appModel.appFamilyName,
                category: appModel.platform,
                version: appModel.codexVersion,
                type: getAppInstallationStatus(appModel, AppsPanelSkeleton.selectedSectionFilter),
            };
            const isNullOrUndefined = value => value === null || typeof value === 'undefined';
            if (appModel.progress && !isNullOrUndefined(appModel.progress)) {
                prevProgress = appModel.progress.percentage * 100;
            }

            if (progressData.totalProgressPercent) {
                currProgress = Number(progressData.totalProgressPercent);
            }
            if (status === ACTIVE_SESSIONS_STATUS.COMPLETED) {
                currProgress = 100;
            }
            if (prevProgress === 0 && currProgress === 0) {
                obj.event.value = '0';
                config.analyticsCallback({ componentParams, analyticObjectList: [obj] });
            }
            if (!isNullOrUndefined(prevProgress) && !isNullOrUndefined(currProgress)) {
                if (currProgress >= 25 && prevProgress < 25) {
                    obj.event.value = '25';
                    config.analyticsCallback({ componentParams, analyticObjectList: [obj] });
                }
                if (currProgress >= 50 && prevProgress < 50) {
                    obj.event.value = '50';
                    config.analyticsCallback({ componentParams, analyticObjectList: [obj] });
                }
                if (currProgress >= 75 && prevProgress < 75) {
                    obj.event.value = '75';
                    config.analyticsCallback({ componentParams, analyticObjectList: [obj] });
                }
                if (currProgress === 100) {
                    obj.event.value = '100';
                    config.analyticsCallback({ componentParams, analyticObjectList: [obj] });
                }
            }
        }
    }
}

export default new ProgressBarAnalytics();
